import React, { useState } from 'react';
import styles from "./ReviewOrganisationApplication.module.scss";
import {useSelector, useDispatch} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {Button} from "@onegovbugs/onegov-react-components";
import { ImportExportDetailsReviewUnit } from '../../../components/importExport/reviewApplication/ImportExportDetailsReviewUnit';
// import { LicenceInformationReviewUnit } from '../../../components/importExport/reviewApplication/LicenceInformationReviewUnit';
import { InterStateDecisionReviewUnit } from '../../../components/importExport/reviewApplication/InterStateDecisionReviewUnit';
import { InterStateContactDetailsReviewUnit } from 'components/importExport/reviewApplication/InterStateContactDetailsReviewUnit';
import { SpeciesDetailsReviewUnit } from 'components/importExport/reviewApplication/SpeciesDetailsReviewUnit';
import { ApplicantDetailReviewUnit } from 'components/importExport/reviewApplication/ApplicantDetailReviewUnit';
import ScrollToTop from "../../../utils/ScrollToTop";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";
import {saveImportExportApplication} from "../../../redux/actions";

const ReviewOrganisationApplication = props => {

  ScrollToTop();
  RedirectIfCaptchaNotSelected(props);

  const dispatch = useDispatch();
  const importExportDetails = useSelector(state => state.importExportDetails);
  // const licenceInformation = useSelector(state => state.licenceInformation);
  const interStateDetails = useSelector(state => state.interStateDetails);
  const speciesDetails = useSelector(state => state.speciesDetails);

  const twoFA = useSelector((state) => state.twoFA);
  const organisationApplicationDetails = useSelector(state => state.organisationApplicationDetails);

  const [twoFAData] = useState(twoFA ? twoFA.data : {firstName:"",lastName:"",day:"",month:"",year:""});

    return <div className={styles.mainCont}>
      <p>
        Please check the information you have entered in this application. If
        you need to correct any of the details, click 'Back' or select the
        relevant section and change the information as appropriate. To proceed
        with the application click 'Next'.
      </p>
    
      <ImportExportDetailsReviewUnit importExportDetails={importExportDetails}/>

      <ApplicantDetailReviewUnit 
        personalDetails={organisationApplicationDetails} 
        twoFAData = {twoFAData} 
        onEditUrl ={"/import-export/organisation-licence-information"}
        props = {props} 
        title = {'Organisation Details'}
        type = "Organisation"
      />   


      <InterStateDecisionReviewUnit 
        importExportDetails={importExportDetails} 
        props={props} 
        onEditUrl={'/import-export/organisation-interstate-decision'}  
      />   

      <InterStateContactDetailsReviewUnit
            interStateDetails = {interStateDetails} 
            props={props}
            title= {`Interstate Person/Organisation Details`}
            onEditUrl={'/import-export/interstate-organisation'}
            interStateType = {importExportDetails.interStateDecisionAppType}
        />       

      <SpeciesDetailsReviewUnit speciesDetails={speciesDetails} props={props} onEditUrl={'/import-export/interstate-organisation-licence'}/>

      <div className={`row ${styles.buttonCont}`}>
        <div className={`col-12`}>
          <Button
            onClick={() => {
              props.history.push(`./organisation-declaration`);
            }}
          >
            Confirm
          </Button>
          <Button
          secondary
          onClick={() => {
            dispatch(
              saveImportExportApplication("", () => {
                  props.history.push(`./organisation-dashboard`);
            })
          ); 
          }}
        >
          Save & exit section
        </Button>
        </div>
      </div>

    </div>
  };
  
  export default withRouter(props => <ReviewOrganisationApplication {...props}/>);
  
